import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { API_URL, ROLE_LABEL } from './chatShared';

export const NewChatDialog = ({ open, onClose, contacts, canGroup, onCreated }) => {
  const [mode, setMode] = useState('direct');
  const [sel, setSel] = useState([]);
  const [name, setName] = useState('');
  const [q, setQ] = useState('');
  const toggle = (id) => setSel((s) => (mode === 'direct' ? [id] : s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const create = async () => {
    try {
      const { data } = await axios.post(`${API_URL}/chat/conversations`, { type: mode, member_ids: sel, name });
      onCreated(data.id);
      setSel([]); setName(''); onClose();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Erro ao criar conversa'); }
  };
  const list = contacts.filter((c) => !q || c.name.toLowerCase().includes(q.toLowerCase()));
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="chat-new-dialog" aria-describedby={undefined}>
        <DialogHeader><DialogTitle>Nova conversa</DialogTitle></DialogHeader>
        {canGroup && (
          <div className="flex gap-2">
            {[['direct', 'Privada'], ['group', 'Grupo']].map(([k, l]) => (
              <button key={k} type="button" onClick={() => { setMode(k); setSel([]); }} data-testid={`chat-new-mode-${k}`}
                className={`text-sm px-3 py-1.5 rounded-full border ${mode === k ? 'bg-[#2D3E6F] text-white border-[#2D3E6F]' : 'border-slate-200 text-slate-600'}`}>{l}</button>
            ))}
          </div>
        )}
        {mode === 'group' && <input value={name} onChange={(e) => setName(e.target.value)} maxLength={60} placeholder="Nome do grupo" className="border border-slate-300 rounded-md px-3 py-2 text-sm" data-testid="chat-new-name" />}
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Pesquisar pessoa" className="border border-slate-200 rounded-md px-3 py-2 text-sm" data-testid="chat-new-search" />
        <div className="max-h-72 overflow-y-auto divide-y divide-slate-100 border border-slate-100 rounded-lg">
          {list.map((c) => (
            <button key={c.id} type="button" onClick={() => toggle(c.id)} data-testid={`chat-contact-${c.id}`}
              className={`w-full text-left px-3 py-2 text-sm flex items-center justify-between ${sel.includes(c.id) ? 'bg-sky-50' : 'hover:bg-slate-50'}`}>
              <span>{c.name}</span><span className="text-xs text-slate-500">{ROLE_LABEL[c.role] || c.role}</span>
            </button>
          ))}
          {!list.length && <p className="p-3 text-sm text-slate-400">Sem contactos.</p>}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button disabled={!sel.length || (mode === 'group' && !name.trim())} onClick={create} className="bg-[#2D3E6F] hover:bg-[#24335c]" data-testid="chat-new-create">Abrir conversa</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
